import { SET_WR_CONTENT } from './wrActions';
import { reformatAccuracyContent } from '../rct/rctAccuracyReducer';

export const defaultState = {
    formId: null,
    isDataFetched: false,
    // 3 fields below will be fully rewritten once content is fetched,
    // but let's keep the structure in default state for completeness' sake
    model: [{
        correctResponse: {},
        possibleResponses: [],
        stimulus: { stimulusAudio: '' },
    }],
    practice: [{
        correctResponse: {},
        possibleResponses: [],
        stimulus: { stimulusAudio: '' },
    }],
    questions: [{
        itemId: null,
        possibleResponses: [],
        stimulus: { stimulusAudio: '' },
    }],
    questionsCount: 0,
    // looks like fields below are no use, but let's keep them listed for just in case
    /*
    grade: null,
    measure: null,
    measureType: null,
    period: null,
    totalItems: {},
    */
};

const wrReducer = (state = defaultState, action) => {
    switch (action.type) {
    case SET_WR_CONTENT: {
        // WR content structure is similar to RCT Accuracy, so no need in different reformat method
        // so, we're just using RCT Accuracy method and picking only fields we need here in WR
        const {
            formId,
            model,
            practice,
            questions,
        } = reformatAccuracyContent(action.content);
        return {
            isDataFetched: true,
            formId,
            model,
            practice,
            questions,
            questionsCount: questions.length,
        };
    }
    default:
        return state;
    }
};

export default wrReducer;
